import React, { FC, useId } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  IconButton,
  Typography,
  Stack,
  Box,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { Button, TextField } from '../../components';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

const ProxyLoginDialog: FC<Props> = ({ open, onClose }) => {
  const id = useId();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography>Login as proxy user</Typography>
          <Box>
            <IconButton size="small">
              <Icon onClick={onClose} icon="ei:close" />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 420, padding: '0px 20px 20px' }}>
        <InputLabel htmlFor={id} sx={{ fontSize: '12px', fontWeight: '400', color: '#000', paddingBottom: '4px' }}>
          Enter email address
        </InputLabel>
        <TextField type="email" id={id} placeholder="john@abc.com" sx={{ fontSize: 12, height: 36 }} />
        <DialogActions sx={{ borderTop: '1px solid #EDEDED', mt: '25px', padding: '10px 0px 0px ' }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={onClose} variant="contained">
            Login
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ProxyLoginDialog;
